export const MANUALLY_HOLD_PERMISSIONS = ['billing.can_manually_hold'];
export const IGNORE_ERROR_PERMISSIONS = ['billing.can_ignore_error'];
export const REFRESH_ROW_PERMISSIONS = ['billing.can_refresh_row'];
export const DELETE_ROW_PERMISSIONS = ['billing.can_delete_row'];
export const EDIT_ROW_PERMISSIONS = ['billing.can_edit_row'];
export const ASSOCIATE_CLAIM_PERMISSIONS = ['billing.can_associate_claim'];
export const SUBMIT_BILLING_REPORT_PERMISSIONS = ['billing.submit_billingreport'];
export const VIEW_BILLING_REPORT_PERMISSIONS = ['billing.view_billingreport'];
export const VIEW_BILLING_REPORT_RESULTS_PERMISSIONS = ['billing.view_billingreportresult'];
